const Vue = window.Vue

Vue.component("HdCarousel", () => import("./app/components/carousel/HdCarousel.vue"))
